"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var index_1 = require("../../../../../shared/index");
var ContextMenu_1 = __importDefault(require("../../../ContextMenu/ContextMenu"));
var Icon_1 = __importDefault(require("../../../Icon/Icon"));
var Label_1 = __importDefault(require("../../../Label/Label"));
var Translate_1 = __importStar(require("../../../Translate/Translate"));
var DocumentContextMenuLink_1 = __importDefault(require("../../styledComponents/DocumentContextMenuLink"));
var SingleDocumentLink_1 = __importDefault(require("../../styledComponents/SingleDocumentLink"));
var SingleDocumentIcon_1 = __importDefault(require("../../styledComponents/SingleDocumentIcon"));
var DownloadTitles_1 = __importDefault(require("../../styledComponents/DownloadTitles"));
var DocumentContextMenu_meta_1 = require("./DocumentContextMenu.meta");
var ksys_app_template_1 = require("@kurtosys/ksys-app-template");
var mobx_1 = require("mobx");
var DocumentContextMenu = /** @class */ (function (_super) {
    __extends(DocumentContextMenu, _super);
    function DocumentContextMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.categoryKey = DocumentContextMenu_meta_1.DOCUMENT_CONTEXT_MENU_CATEGORY_KEY;
        _this.componentKey = DocumentContextMenu_meta_1.DOCUMENT_CONTEXT_MENU_COMPONENT_KEY;
        return _this;
    }
    Object.defineProperty(DocumentContextMenu.prototype, "parentComponentKey", {
        get: function () {
            return DocumentContextMenu_meta_1.DOCUMENT_CONTEXT_MENU_PARENT_COMPONENT_KEY;
        },
        enumerable: true,
        configurable: true
    });
    DocumentContextMenu.prototype.translate = function (ariaLabelText, placeholders) {
        if (placeholders === void 0) { placeholders = {}; }
        if (this.translationContext) {
            return this.translationContext.translate(ariaLabelText, placeholders);
        }
        return ksys_app_template_1.utils.replacePlaceholders({ values: placeholders, text: ariaLabelText });
    };
    Object.defineProperty(DocumentContextMenu.prototype, "ariaLabelPrefix", {
        get: function () {
            var ariaLabelPrefix = this.props.ariaLabelPrefix;
            if (ariaLabelPrefix) {
                return this.translate(ariaLabelPrefix) + ", ";
            }
            return '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentContextMenu.prototype, "documents", {
        get: function () {
            var _a = this.props, getDocumentsCallback = _a.getDocumentsCallback, dataConfig = _a.data, rowData = _a.payload, itemTemplate = _a.itemTemplate;
            return getDocumentsCallback ? getDocumentsCallback(rowData, dataConfig, itemTemplate) : [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentContextMenu.prototype, "noDataOptions", {
        get: function () {
            var _a = this.props, noDataOptions = _a.noDataOptions, payload = _a.payload;
            if (noDataOptions) {
                return noDataOptions.find(function (option) {
                    if (!option.conditional) {
                        return true;
                    }
                    var conditionalHelper = new ksys_app_template_1.helpers.ConditionalHelper(option.conditional);
                    var response = conditionalHelper.matchesWithOptions({ instance: payload, executionOptions: { responseContext: payload } });
                    return response;
                });
            }
        },
        enumerable: true,
        configurable: true
    });
    DocumentContextMenu.prototype.render = function () {
        var _this = this;
        var _a = this.props, describedById = _a.describedById, itemIconProps = _a.itemIconProps, _b = _a.label, label = _b === void 0 ? '' : _b, labelIconProps = _a.labelIconProps, _c = _a.iconPosition, iconPosition = _c === void 0 ? 'after' : _c, singleDocument = _a.singleDocument;
        var hasDocuments = this.documents.length > 0;
        if (!hasDocuments && this.noDataOptions) {
            var _d = this.noDataOptions, _e = _d.hide, hide = _e === void 0 ? false : _e, _f = _d.noDataPlaceholder, noDataPlaceholder = _f === void 0 ? '-' : _f;
            if (hide) {
                return null;
            }
            return react_1.default.createElement(Translate_1.default, null, noDataPlaceholder);
        }
        if (this.documents.length === 1 && singleDocument && singleDocument.displayType === 'icon') {
            var iconProps = singleDocument.iconProps;
            var document_1 = this.documents[0];
            return (react_1.default.createElement(SingleDocumentLink_1.default, { href: document_1.href, target: document_1.linkTarget },
                react_1.default.createElement(SingleDocumentIcon_1.default, __assign({}, iconProps))));
        }
        return (react_1.default.createElement(Translate_1.TranslationContext.Consumer, null, function (translationContext) {
            _this.translationContext = translationContext;
            return (react_1.default.createElement(ContextMenu_1.default, { label: label, labelIcon: labelIconProps, describedById: describedById }, _this.documents.map(function (document, index) {
                var title = document.title, subTitle = document.subTitle, href = document.href, _a = document.linkTarget, linkTarget = _a === void 0 ? '_blank' : _a;
                var documentTitle = (react_1.default.createElement(Label_1.default, { title: _this.translate("{downloadControlsPrefix} download controls", {
                        downloadControlsPrefix: "" + _this.ariaLabelPrefix + title,
                    }) },
                    react_1.default.createElement(Translate_1.default, null, title)));
                var documentSubTitle = (react_1.default.createElement(Label_1.default, { title: _this.translate("{downloadControlsPrefix} download controls", {
                        downloadControlsPrefix: "" + _this.ariaLabelPrefix + subTitle,
                    }) },
                    react_1.default.createElement(Translate_1.default, null, subTitle)));
                var icon = itemIconProps && react_1.default.createElement(Icon_1.default, __assign({}, itemIconProps));
                return (react_1.default.createElement(DocumentContextMenuLink_1.default, { key: "document_item_" + index, href: href, target: linkTarget },
                    iconPosition === 'before' && icon,
                    react_1.default.createElement(DownloadTitles_1.default, null,
                        documentTitle,
                        documentSubTitle),
                    iconPosition === 'after' && icon));
            })));
        }));
    };
    __decorate([
        mobx_1.observable
    ], DocumentContextMenu.prototype, "categoryKey", void 0);
    __decorate([
        mobx_1.observable
    ], DocumentContextMenu.prototype, "componentKey", void 0);
    __decorate([
        mobx_1.observable
    ], DocumentContextMenu.prototype, "analyticsHelper", void 0);
    __decorate([
        mobx_1.observable
    ], DocumentContextMenu.prototype, "translationContext", void 0);
    __decorate([
        mobx_1.computed
    ], DocumentContextMenu.prototype, "parentComponentKey", null);
    __decorate([
        mobx_1.action
    ], DocumentContextMenu.prototype, "translate", null);
    __decorate([
        mobx_1.computed
    ], DocumentContextMenu.prototype, "ariaLabelPrefix", null);
    __decorate([
        mobx_1.computed
    ], DocumentContextMenu.prototype, "documents", null);
    __decorate([
        mobx_1.computed
    ], DocumentContextMenu.prototype, "noDataOptions", null);
    return DocumentContextMenu;
}(index_1.ComponentBase));
exports.DocumentContextMenu = DocumentContextMenu;
var StyledDocumentContextMenu = index_1.InjectedStyledComponent(mobx_react_1.observer(DocumentContextMenu), DocumentContextMenu_meta_1.DOCUMENT_CONTEXT_MENU_CATEGORY_KEY, DocumentContextMenu_meta_1.DOCUMENT_CONTEXT_MENU_PARENT_COMPONENT_KEY, [DocumentContextMenu_meta_1.DOCUMENT_CONTEXT_MENU_COMPONENT_KEY]);
exports.default = StyledDocumentContextMenu;
